import { Component } from '@angular/core';
import { DialogService } from 'src/app/services/dialogService/dialog-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class FooterComponent {
  copyYear = new Date().getFullYear();
  env = environment;
  editorialUrls =environment.urls;
  constructor(public dialogService: DialogService) { }
}